import { ImageEntity } from "@client/content/controls/Image/container";
import { getMediaUrl } from "@client/content/controls/Media/lib";
import date from "@client/lib/date";
import { default as classnames } from "classnames";
import * as React from "react";
import { type EventsModule } from "../../types";
import { type EventItemContainerProps } from "./container";

export type EventItemMapProps = EventItemContainerProps & {
  imageStyle: React.CSSProperties;
  event: EventsModule.Event;
  nameStyle: React.CSSProperties;
  locationStyle: React.CSSProperties;
  dateStyle: React.CSSProperties;
  noImageUrl: string;

  showOverlay: boolean;
  overlayColor: string | undefined;
};

export interface EventItemActionProps {
  onClick: () => void;
}

export type EventItemProps = EventItemActionProps & EventItemMapProps;
const EventItem = ({ onClick, ...props }: EventItemProps) => {
  return (
    <div className={classnames("item pointer")} onClick={onClick}>
      <div className="inner">
        <div className="image">
          <ImageEntity
            id={props.parentId}
            source={props.source}
            src={
              props.event.thumbnailMediaSourceKey
                ? getMediaUrl(props.event.thumbnailMediaSourceKey, props.event.thumbnailMediaSourceId!)
                : props.noImageUrl
            }
            style={props.imageStyle}
          />
        </div>
      </div>

      {props.showOverlay && (
        <div className="overlay" style={{ backgroundColor: props.overlayColor }}>
          <span className="name" style={props.nameStyle}>
            {props.event.name}
          </span>
          <span className="venue" style={props.locationStyle}>
            {props.event.venueName}
          </span>
          <div className="gap" />
          <span className="date" style={props.dateStyle}>
            {date.formatRange(props.event.startDate, props.event.endDate, {
              year: "numeric",
              month: "short",
              day: "numeric"
            })}
          </span>
        </div>
      )}
    </div>
  );
};
export default EventItem;
